module.exports = __webpack_public_path__ + "static/media/sslcommerz_pgw_logo.a267f2f1.svg";